import React, { Component } from "react";
import { QUESTION_IDS, ANSWER_IDS, STRINGS, UI } from "../constants";
import { track } from "@amplitude/analytics-browser";
import { AMPLITUDE_EVENTS } from "../config/amplitude";
import { UserDetailsService } from "../services/userDetailsService";

class Slide2_2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Advisor: [],
      errors: {},
    };
  }

  componentDidMount() {
    // Track survey step view
    track(AMPLITUDE_EVENTS.SURVEY_VIEW_STEP, {
      page_type: "Slide2_2",
      step: this.props.values.step,
      requestId: this.props.values.requestId,
      medium: this.props.values.medium,
    });

    // Use centralized service to fetch user details
    UserDetailsService.fetchAndUpdateState(
      this.props.values.requestId,
      this,
      'Advisor',
      {
        componentName: "Slide2_2",
        medium: this.props.values.medium,
      }
    );
  }

  handlesubmit = event => {
    if (this.validateForm()) {
      if (this.props.values.decision === "") {
        var decision = STRINGS.NA;
      } else {
        var decision = this.props.values.decision;
      }

      const obj12 = {
        requestid: this.props.values.requestId,
        medium: this.props.values.medium,
        answerId: ANSWER_IDS.DECISION_ANSWER,
        questionId: QUESTION_IDS.ASSIST_DECISION_MAKING,
        responseInfo: decision,
        createDt: this.props.values.date,
      };
      const obj13 = {
        requestid: this.props.values.requestId,
        medium: this.props.values.medium,
        answerId: this.props.values.distance,
        questionId: QUESTION_IDS.LOCATION_DISTANCE_IMPORTANCE,
        responseInfo: STRINGS.NA,
        createDt: this.props.values.date,
      };
      const obj14 = {
        requestid: this.props.values.requestId,
        medium: this.props.values.medium,
        answerId: ANSWER_IDS.SPOKEN_TO_ANSWER,
        questionId: QUESTION_IDS.WHICH_ADVISORS_SPOKEN_TO,
        responseInfo: this.props.values.advisorpokenTo.toString(),
        createDt: this.props.values.date,
      };
      // console.log(obj12,obj13,obj14)
      this.props.handleSubmit3(obj12, obj13, obj14);
    }
  };

  validateForm() {
    let fields = this.state;
    let errors = {};
    let formIsValid = true;
    // if(this.props.values.decision==="") {
    //     formIsValid = false;
    //     errors["decisionerror"] = "Kindly select an option below to proceed";
    //   }

    if (this.props.values.distance === "") {
      formIsValid = false;
      errors["locationerror"] = "Kindly select an option below to proceed";
    }
    if (!this.props.values.advisorpokenTo.length) {
      formIsValid = false;
      errors["spokenToerror"] = "Kindly select an option below to proceed";
    }

    this.setState({
      errors: errors,
    });

    // Track validation errors if form is invalid
    if (!formIsValid) {
      track(AMPLITUDE_EVENTS.SURVEY_ANSWER_SUBMISSION_ERROR, {
        component: "Slide2_2",
        error: "Form validation failed",
        requestId: this.props.values.requestId,
        medium: this.props.values.medium,
        step: "slide2_2_form_validation",
        validationErrors: errors,
        errorMessages: Object.values(errors),
        errorCount: Object.keys(errors).length,
      });
    }

    return formIsValid;
  }

  back = e => {
    e.preventDefault();
    this.props.prevStep();
  };

  render() {
    const { handleInput, handlecheckbox2, values } = this.props;
    return (
      <>
        <section className="feedback-service">
          <div className="container" style={{ textAlign: "left" }}>
            <div className="row">
              <div className="col-md-12">
                <h2>
                  Which of the advisor matches have you spoken to?
                  <div id="rsp_email" className="error">
                    {this.state.errors.spokenToerror}
                  </div>
                </h2>

                {this.state.Advisor.map(checkbox => (
                  <label className="radio-inline" key={checkbox.sellerId}>
                    <input
                      type="checkbox"
                      disabled={values.checknon === "None of the above"}
                      checked={values.advisorpokenTo.includes(
                        checkbox.sellerNm + "(Sid-" + checkbox.sellerId + ")"
                      )}
                      name={checkbox.sellerNm}
                      value={checkbox.sellerId}
                      onChange={handlecheckbox2}
                    />
                    {checkbox.sellerNm}
                  </label>
                ))}
                <label className="radio-inline">
                  <input
                    type="checkbox"
                    name="spokenTo"
                    checked={values.advisorpokenTo.includes(
                      "None of the above"
                    )}
                    value="None of the above"
                    onChange={handlecheckbox2}
                  />
                  None of the above
                </label>
              </div>

              <div className="col-md-12">
                <h2>
                  How important is the location and the distance of your desired
                  advisor from where you are located?
                  <div id="rsp_email" className="error">
                    {this.state.errors.locationerror}
                  </div>
                </h2>

                <label className="radio-inline">
                  <input
                    type="radio"
                    checked={values.distance === ANSWER_IDS.NOT_IMPORTANT}
                    name="distance"
                    value={ANSWER_IDS.NOT_IMPORTANT}
                    onChange={handleInput(this)}
                  />
                  Not important
                </label>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="distance"
                    checked={values.distance === ANSWER_IDS.SOMEWHAT_IMPORTANT}
                    value={ANSWER_IDS.SOMEWHAT_IMPORTANT}
                    onChange={handleInput(this)}
                  />
                  Somewhat important
                </label>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="distance"
                    checked={values.distance === ANSWER_IDS.VERY_IMPORTANT}
                    value={ANSWER_IDS.VERY_IMPORTANT}
                    onChange={handleInput(this)}
                  />
                  Very important
                </label>
              </div>

              <div className="col-md-12">
                <h2>
                  Is there anything we can do to assist you with your decision
                  making process?
                </h2>
                <input
                  type="text"
                  className="additional"
                  name="decision"
                  value={values.decision}
                  onChange={handleInput(this)}
                ></input>
                <div id="rsp_email" className="error">
                  {this.state.errors.decisionerror}
                </div>
              </div>

              <div className="col-md-3"></div>
              <div className="col-md-6">
                <input
                  type="button"
                  name="previous"
                  className="next btn-update action-button nextOne"
                  style={{ cursor: "pointer" }}
                  value="PREVIOUS"
                  onClick={this.back}
                />
                <input
                  type="button"
                  name="next"
                  className="next btn-update action-button nextOne"
                  style={{
                    cursor: "pointer",
                    marginLeft: UI.MARGIN_LEFT,
                  }}
                  value="NEXT"
                  onClick={this.handlesubmit}
                />
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default Slide2_2;
